var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiagonalArrow = function SvgDiagonalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M4.788 4.122h6.845a.5.5 0 0 1 .5.5v6.845m-7.23-.115 6.947-6.948"
  })));
};
export { SvgDiagonalArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik00Ljc4ODQ1IDQuMTIxN2g2Ljg0NDk1Yy4yNzYyIDAgLjUuMjIzODYuNS41djYuODQ1TTQuOTAyNDE3IDExLjM1MTZsNi45NDcxODQ4NS02Ljk0NzE4NDg1IiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvc3ZnPg==";